import { render, staticRenderFns } from "./ElementBrand.vue?vue&type=template&id=ee69ce5c&"
import script from "./ElementBrand.vue?vue&type=script&lang=js&"
export * from "./ElementBrand.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports